import React, { Fragment } from 'react';
import { TouchableOpacity } from 'react-native';
import ReactModal from 'react-modal';
import Text from '../../react-component/textComponent';
import styles from './styles';
import Colors from '../../config/Colors';

const URL_WHATS =
    'https://api.whatsapp.com/send/?phone=554635368500&text&app_absent=0';
const URL_ME_AJUDA = 'https://atendimento.ciss.com.br';

const modalAjuda = ({ isOpen = false, onClose }) => {
    function openURL(url) {
        window.open(url, '_blank');

        onClose();
    }

    return (
        <Fragment>
            <ReactModal isOpen={isOpen} style={styles.modal}>
                <div style={styles.container}>
                    <Text style={styles.textModal} $bold>
                        Onde prefere nos chamar?
                    </Text>

                    <br />

                    <Text style={styles.textModal}>
                        Responderemos o quanto antes!
                    </Text>

                    <div style={{ padding: 16 }} />

                    <TouchableOpacity
                        onPress={() => openURL(URL_WHATS)}
                        style={[styles.button, { backgroundColor: '#3BC141' }]}
                    >
                        <Text
                            style={{
                                fontSize: '1.6rem',
                                fontFamily: 'NunitoSans-Regular',
                                color: '#fff'
                            }}
                        >
                            <Text style={styles.textModal} $bold>
                                WhatsApp da CISS
                            </Text>
                        </Text>
                    </TouchableOpacity>

                    <div style={styles.spaceFiller} />

                    <TouchableOpacity
                        onPress={() => openURL(URL_ME_AJUDA)}
                        style={styles.button}
                    >
                        <Text
                            style={{
                                fontFamily: 'NunitoSans-Regular',
                                fontSize: '1.6rem',
                                color: '#fff'
                            }}
                        >
                            <Text style={styles.textModal} $bold>
                                atendimento.ciss.com.br
                            </Text>
                        </Text>
                    </TouchableOpacity>

                    <div style={styles.spaceFiller} />

                    <TouchableOpacity
                        onPress={onClose}
                        style={[
                            styles.button,
                            {
                                backgroundColor: Colors.white,
                                borderWidth: 2,
                                borderColor: Colors.secondary
                            }
                        ]}
                    >
                        <Text
                            style={{
                                fontFamily: 'NunitoSans-Regular',
                                color: Colors.secondary,
                                fontSize: '1.6rem'
                            }}
                        >
                            <Text style={styles.textModal} $bold>
                                Cancelar
                            </Text>
                        </Text>
                    </TouchableOpacity>
                </div>
            </ReactModal>
        </Fragment>
    );
};

export default modalAjuda;
